import { render } from "./grupolistadodocumentacionmasterdetail.vue?vue&type=template&id=9c22efd0"
import script from "./grupolistadodocumentacionmasterdetail.vue?vue&type=script&lang=js"
export * from "./grupolistadodocumentacionmasterdetail.vue?vue&type=script&lang=js"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__